import React from "react";

const SkeletonCard = ({ 
  width = "w-full", 
  height = "h-4", 
  className = "", 
  rounded = "rounded",
  animate = true 
}) => {
  return (
    <div 
      className={`
        bg-white/10 
        ${width} 
        ${height} 
        ${rounded} 
        ${animate ? 'animate-pulse' : ''} 
        ${className}
      `}
    />
  );
};

export default SkeletonCard; 